export interface GallerySlide {
  title: string
  src: string
  alt: string
}

export const gallerySlides: GallerySlide[] = [
  {
    title: 'The 7 Phases of a Taekwondo Kick',
    src: 'https://cdn.magicpatterns.com/uploads/sXYVtcntFxWxHSbkuvazkA/Captura_de_pantalla_2026-09-21_180820.png',
    alt: 'Poster breaking a Taekwondo kick into seven phases: set, chamber, pivot, extend, contact, recoil and recover',
  },
  {
    title: 'Roundhouse Kick — 10-Level Development Ladder',
    src: 'https://cdn.magicpatterns.com/uploads/8mQhuEzoiYcAVU9Q6TvxP4/Captura_de_pantalla_2026-09-21_180845.png',
    alt: 'Ten-level progression ladder for the roundhouse kick, from pivot only up to reaction-based application',
  },
  {
    title: '10 Ready-to-Use Pad Work Drills',
    src: 'https://cdn.magicpatterns.com/uploads/rExbDgXuru66bapNWmvbtS/Captura_de_pantalla_2026-09-21_180917.png',
    alt: 'Ten pad work drills with setup, reps, coaching focus and main error for each drill',
  },
  {
    title: '60-Minute Ready-to-Teach Kicking Class',
    src: 'https://cdn.magicpatterns.com/uploads/at4q3uPjT6K4SrmMkrYqap/Captura_de_pantalla_2026-09-21_180940.png',
    alt: 'Complete 60-minute kicking class plan with time blocks, drills, reps, coaching cues, equipment and common errors',
  },
  {
    title: 'Universal Kicking Corrections',
    src: 'https://cdn.magicpatterns.com/uploads/oPEZLN86AfkZui5BrpLJpR/Captura_de_pantalla_2026-09-21_181118.png',
    alt: 'Eight universal kicking corrections shown as correct versus incorrect technique comparisons',
  },
]
